'use client';

const PTR_STORAGE_KEY = 'pull-to-refresh';

/** pull to refresh를 허용/비허용 한다. */
export const togglePullToRefresh = (on: boolean) => {
  if (!window) return;

  const storedOn = getPTRState();
  const shouldUpdate = on !== storedOn;
  if (shouldUpdate) {
    sendPTRStateInterfaceToApp(on);
  }
  setPTRState(on);
};

const getPTRState = () => {
  return globalThis.window.sessionStorage.getItem(PTR_STORAGE_KEY) === 'true' ? true : false;
};

const setPTRState = (on: boolean) => {
  globalThis.window.sessionStorage.setItem(PTR_STORAGE_KEY, String(on));
};

const sendPTRStateInterfaceToApp = (on: boolean) => {
  if (!window) return;

  const message = {
    cmd: 'pullToRefresh',
    parameters: {
      onOffFrag: on,
    },
  };

  globalThis.window.webkit?.messageHandlers?.Common?.postMessage?.(message);
  globalThis.window.Common?.pullToRefresh?.(on);
  globalThis.window.Android?.pullToRefresh?.(on);
};
